module.exports = __webpack_public_path__ + "static/media/about-mission.921dde0c.jpg";